const swiper06 = new Swiper('.about-us-carousel', {
    direction: 'horizontal',
    slidesPerView: 1,
    breakpoints: {
        769:{
            slidesPerView: 3.5,
        },
        426:{
            slidesPerView: 2.2,
        }
    }
})